<template>
	<article class="small-12 flex potentialActual sidebarWidget animated fadeIn" v-if="property">
        <div class="small-12 title">
            <h3 class="flex vertical-align">Potential vs. Actual</h3>
        </div>
        <div class="small-12 potentialVActual border light widget borderRadius8 columns bgWhite">
            <ul class="small-12 flex">
                <li class="small-12 flex vertical-align">
                    <p class="small-12 large-6 columns">
                        <b>Actual Rent:</b>
                    </p>
                    <p class="small-12 large-6 columns flex justify-right">
                        <span v-if="actualRent > 0">${{ actualRent | twoDecimals }}</span>
                        <span v-else>$0.00</span>
                    </p>
                </li>
                <li class="small-12 flex vertical-align">
                    <p class="small-12 large-6 columns">
                        <b>Market Rent:</b>
                    </p>
                    <p class="small-12 large-6 columns flex justify-right">
                        <span v-if="potentialRent > 0">${{ potentialRent | twoDecimals }}</span>
                        <span v-else>$0.00</span>
                    </p>
                </li>
                <li class="small-12 columns flex vertical-align horizLine">
                    <span></span>
                </li>
                <li class="small-12 flex vertical-align difference">
                    <p class="small-12 large-5 columns">
                        <b>Difference:</b>
                    </p>
                    <p class="small-12 large-7 columns flex justify-right vertical-align">
                        <i class="material-icons-outlined cGreen" v-if="marketVActual >= 0">arrow_circle_up</i>
                        <i class="material-icons-outlined cRed" v-if="marketVActual < 0">arrow_circle_down</i>
                        <span class="cGreen" v-if="marketVActual >= 0">${{marketVActual | twoDecimals}}</span>
                        <span class="cRed" v-if="marketVActual < 0">${{marketVActual | twoDecimals}}</span>
                    </p>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>

    // Import firebase
	import { propertiesModel } from '@/firebase/firebase-config'

    // Import the filters
    import { AbbreviateNumbersFilters } from '@/mixins/filters/AbbreviateNumbersFilters'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PotentialActual',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			AbbreviateNumbersFilters

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
                type: Object,
                value: () => null
            },

            units: {
                type: Array, 
                value: () => []
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			actualRent: 0,
            potentialRent: 0

		}),

		/*
		**  Watch em'
		*/

		watch: {

			units: {

				immediate: true, // Load on created
				handler(units) {

                    /*
					**  Calculate the metrics
					**  @method: @here
					*/

					if (units && units.length > 0) this.calculatePotentialActual();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			calculatePotentialActual: function() {

                try {

                    /*
					**  Loop through em'
					*/

                    this.units.forEach(unit => {

                        /*
                        **  Set the potential rent
                        **  @prop: @here
                        */

                        if (unit.attributes.rent.market > 0) this.potentialRent = this.potentialRent + unit.attributes.rent.market;

                        /*
                        **  Get the lease
                        **  @service: @Firebase/Firestore
                        */

                        if (unit.relationships.lease) {

                            propertiesModel.doc(this.$route.params.id).collection('leases').doc(unit.relationships.lease).get()
                            .then(doc => {

                                if (!doc.exists) return;

                                /*
                                **  Set the var
                                */

                                let lease = doc.data();

                                /*
                                **  Set the actual rent
                                **  @prop: @here
                                */

                                if (lease.attributes.status == 'active') this.actualRent = this.actualRent + lease.attributes.rent.amount;

                            })
                            .catch(error => {

                                /*
                                **  Send to Bugsnag
                                **  @service: Bugsnag/BugsnagService
                                */
                            
                                this.reportAuthBugsnagError({
                                    title: 'Unable to get the unit active lease to calculate actual vs. potential metrics.',
                                    errorType: 'Application',
                                    section: 'PotentialActual',
                                    uid: 'OdqgpELuei6zokgSwcnp',
                                    error: error
                                });

                            });

                        }

                    });

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to calculate the potential vs actual metrics.',
						errorType: 'Application',
						section: 'PotentialActual',
						uid: 'vT46R3BA6qykcM6B8OeY',
						error: e
					});

                }

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			marketVActual: function() {

				return this.actualRent - this.potentialRent;

			}

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>